import { AnimationObserver } from '@relay/client';

new AnimationObserver({ rootMargin: '0px 0px -40px 0px', threshold: 0 });
